import { TEAM_ROOT } from '@/domains/admin';

/**
 * Where the website's content screens live — `/team/website/*` (§7.11, WEB-05).
 *
 * Spelled in the domain beside the screens that link to one another, as `domains/admin/paths.ts`
 * is and for the same reason: a screen's address must not depend on the shell it happens to be
 * drawn in. The zone's route module mounts what these name.
 *
 * `TEAM_ROOT` is imported rather than re-spelled so the two cannot drift. That is the one thing
 * this domain takes from the admin domain; nothing else crosses.
 */

export const CONTENT_ROOT = `${TEAM_ROOT}/website`;

export const CONTENT_PATHS = {
  overview: CONTENT_ROOT,
  news: `${CONTENT_ROOT}/news`,
  team: `${CONTENT_ROOT}/team`,
  events: `${CONTENT_ROOT}/events`,
  media: `${CONTENT_ROOT}/media`,
  pages: `${CONTENT_ROOT}/pages`,
  access: `${CONTENT_ROOT}/access`
} as const;

/** One post, opened beside the news list. */
export function postPath(postId: string): string {
  return `${CONTENT_PATHS.news}/${encodeURIComponent(postId)}`;
}

/** One event, opened beside the events list — an event's agenda and speakers are somewhere an
 *  author stays, which is the reason a post has an address of its own. */
export function eventPath(eventId: string): string {
  return `${CONTENT_PATHS.events}/${encodeURIComponent(eventId)}`;
}
